
<div class="content-wrapper pt-2"> 
    <section class="content">
      <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Invoice</div>

        <form [formGroup]="invoiceForm"  autocomplete="off"  class="form-horizontal">   
        <div class="card-body">   
          <div class="row"> 
            <div class="col-md-12">
            <table class="table table-row-color table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
    
                <tbody class="ml-1">                    

                  <tr class="table-row-color">
                    <td style="width: 19%;" colspan="8">
                      <mat-radio-group formControlName="invoiceType" (change)="checkedChangeRdoButtons($event)">  
                        <mat-radio-button class="ml-4" value="INVOICE">INVOICE</mat-radio-button>
                        <mat-radio-button class="ml-4" value="VAT INVOICE" >VAT INVOICE</mat-radio-button>
                        <mat-radio-button class="ml-4" value="SVAT INVOICE">SVAT INVOICE</mat-radio-button>
                      </mat-radio-group>
                    </td>
                  </tr>

                  <tr class="table-row-color">    
                    <input readonly formControlName="id"  class="form-control"    type="hidden">                  
                    <td style="width: 6%;" class="table-light">Inv.No</td> 
                    <td style="width: 19%;">
                        <input type="text" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="invoiceNo" class="form-control field-bg-color form-control-sm" [class.is-invalid]="formErrors.invoiceNo" (blur)="logValidationErrors()" placeholder="Invoice No">
                      <span class="text-danger" *ngIf="formErrors.invoiceNo"><small>{{formErrors.invoiceNo}}</small> </span>   
                    </td> 
                    <td style="width: 6%;">Date</td> 
                    <td style="width: 19%;"> 
                      <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfigDate" formControlName="invoiceDate" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.invoiceDate" (blur)="logValidationErrors()" placeholder="Invoice Date">
                      <span class="text-danger" *ngIf="formErrors.invoiceDate"><small>{{formErrors.invoiceDate}}</small> </span>   
                  </td> 
                  <td style="width: 6%;">H.Type</td> 
                  <td style="width: 19%;">
                          <select [ngClass]="{'dark-input-field' : isDark }" formControlName="hireType" class="form-control form-control-sm  field-bg-color"   [class.is-invalid]="formErrors.hireType" (blur)="logValidationErrors()">        
                            <option [ngValue]="null">-Select-</option>
                            <option *ngFor="let item of HIRE_TYPE" [value]="item.value">
                              {{item.value}}
                            </option>
                        </select>
                        <span class="text-danger" *ngIf="formErrors.hireType"><small>{{formErrors.hireType}}</small> </span>   
                  </td> 
                  <td style="width: 6%;">H.Mode</td> 
                  <td style="width: 19%;"> 
                    <select [ngClass]="{'dark-input-field' : isDark }" formControlName="hireMode" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.hireMode" (blur)="logValidationErrors()">        
                      <option [ngValue]="null">-Select-</option>
                      <option *ngFor="let item of HIRE_MODE" [value]="item.value">
                        {{item.value}}
                      </option>
                  </select>
                  <span class="text-danger" *ngIf="formErrors.hireMode"><small>{{formErrors.hireMode}}</small> </span> 
                </td>                  
                </tr>  

                <tr class="table-row-color">                      
                  <td style="width: 6%;">Customer</td> 
                  <td style="width: 19%;" colspan="2">
                    <input  name="cusId" readonly formControlName="cusId"  class="form-control"    type="hidden">
                    <input [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="cusName" (focusout)="getCustomerDetails()"  [matAutocomplete]="autoCustomer" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.cusName" (blur)="logValidationErrors()" placeholder="Customer Name">
                    <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                      <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.CusName">
                        {{option.CusName}}
                      </mat-option>
                    </mat-autocomplete>                
                  <span class="text-danger" *ngIf="formErrors.cusName"><small>{{formErrors.cusName}}</small> </span>   
                  </td> 
                  <td style="width: 6%;">Address</td> 
                  <td style="width: 19%;" colspan="2"> 
                    <input [ngClass]="{'dark-input-field' : isDark }" readonly class="form-control form-control-sm field-bg-color" formControlName="address"  [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()" placeholder="Address">
                  <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
                </td> 
                <td style="width: 6%;">Fac.Lo</td> 
                <td style="width: 19%;">
                  <input [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="factoryLocation"  placeholder="Factory Location">
                </td>                   
              </tr>  

              <tr class="table-row-color">                      
                <td style="width: 6%;">Vehicle</td> 
                <td style="width: 19%;">
                  <input type="text"  list="vehicles" placeholder="-Select-" formControlName="vehicle"  class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.vehicle" (blur)="logValidationErrors()">
                    <datalist id="vehicles">
                    <option *ngFor="let item of vehicleList" [value]="item.VehicleNo">
                      {{item.VehicleNo}}
                    </option>
                  </datalist>
                <span class="text-danger" *ngIf="formErrors.vehicle"><small>{{formErrors.vehicle}}</small> </span>   
                </td> 
                <td style="width: 6%;">Veh.Type</td> 
                <td style="width: 19%;">
                  <select [ngClass]="{'dark-input-field' : isDark }" formControlName="vehicleType" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.vehicleType" (blur)="logValidationErrors()">        
                    <option [ngValue]="null">-Select-</option>
                    <option *ngFor="let item of VEHICLE_TYPE" [value]="item.value">
                      {{item.value}}
                    </option>
                </select>
                <span class="text-danger" *ngIf="formErrors.vehicleType"><small>{{formErrors.vehicleType}}</small> </span>  
              </td> 
              <td style="width: 6%;">Cont.Type</td> 
              <td style="width: 19%;">
                <select [ngClass]="{'dark-input-field' : isDark }" (change)="containerTypeChangeEvent($event)" formControlName="containerType" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.containerType" (blur)="logValidationErrors()">        
                  <option [ngValue]="null">-Select-</option>
                  <option>(+) New</option>
                  <option *ngFor="let item of containerTypeList" [value]="item.ContainerType">
                    {{item.ContainerType}}
                  </option>
              </select>
              <span class="text-danger" *ngIf="formErrors.containerType"><small>{{formErrors.containerType}}</small> </span>  
              </td> 
              <td style="width: 6%;">Con.No</td> 
              <td style="width: 19%;"> 
                <input [ngClass]="{'dark-input-field' : isDark }"  class="form-control field-bg-color form-control-sm" formControlName="containerNo"  placeholder="Container No">
            </td>                  
            </tr>     
            
            <tr class="table-row-color">                      
              <td style="width: 6%;">RT</td> 
              <td style="width: 19%;">
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="requestTime" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.requestTime" (blur)="logValidationErrors()" placeholder="Request Time">
              <span class="text-danger" *ngIf="formErrors.requestTime"><small>{{formErrors.requestTime}}</small> </span>   
              </td> 
              <td style="width: 6%;">FIT</td> 
              <td style="width: 19%;">
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="factoryInTime" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.factoryInTime" (blur)="logValidationErrors()" placeholder="Factory In Time">
              <span class="text-danger" *ngIf="formErrors.factoryInTime"><small>{{formErrors.factoryInTime}}</small> </span> 
            </td> 
            <td style="width: 6%;">DST</td> 
            <td style="width: 19%;">
              <input type="text" [ngClass]="{'dark-input-field' : isDark }"  (focusout)="getChargableHours()" bsDatepicker [bsConfig]="datepickerConfig" formControlName="detentionStartTime" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.detentionStartTime" (blur)="logValidationErrors()" placeholder="Detention Start Time">
            <span class="text-danger" *ngIf="formErrors.detentionStartTime"><small>{{formErrors.detentionStartTime}}</small> </span> 
            </td> 
            <td style="width: 6%;">FT</td> 
            <td style="width: 19%;"> 
              <input type="text" [ngClass]="{'dark-input-field' : isDark }"  (focusout)="getChargableHours()" bsDatepicker [bsConfig]="datepickerConfig" formControlName="finishedTime" class="form-control form-control-sm field-bg-color"  [class.is-invalid]="formErrors.finishedTime" (blur)="logValidationErrors()" placeholder="Finished Time">
            <span class="text-danger" *ngIf="formErrors.finishedTime"><small>{{formErrors.finishedTime}}</small> </span> 
          </td>                  
          </tr>   
          
          <tr class="table-row-color">                      
            <td style="width: 6%;">Chrg.Hrs</td> 
            <td style="width: 19%;">
              <input [ngClass]="{'dark-input-field' : isDark }" class="form-control form-control-sm field-bg-color" formControlName="chargingHours"  [class.is-invalid]="formErrors.chargingHours" (blur)="logValidationErrors()" placeholder="Charging Hours">
            <span class="text-danger" *ngIf="formErrors.chargingHours"><small>{{formErrors.chargingHours}}</small> </span>
            </td> 
            <td style="width: 6%;">From</td> 
            <td style="width: 19%;">
              <select [ngClass]="{'dark-input-field' : isDark }" (change)="fromLocationChangeEvent($event)" formControlName="fromLocation" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.fromLocation" (blur)="logValidationErrors()">        
                <option [ngValue]="null">-Select-</option>
                <option>(+) New</option>
                <option *ngFor="let item of locationList" [value]="item.Location">
                  {{item.Location}}
                </option>
            </select>
            <span class="text-danger" *ngIf="formErrors.fromLocation"><small>{{formErrors.fromLocation}}</small> </span>  
          </td> 
          <td style="width: 6%;">To</td> 
          <td style="width: 19%;">
            <select [ngClass]="{'dark-input-field' : isDark }" (change)="toLocationChangeEvent($event)" formControlName="toLocation" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.toLocation" (blur)="logValidationErrors()">        
              <option [ngValue]="null">-Select-</option>
              <option>(+) New</option>
              <option *ngFor="let item of locationList" [value]="item.Location">
                {{item.Location}}
              </option>
          </select>
          <span class="text-danger" *ngIf="formErrors.toLocation"><small>{{formErrors.toLocation}}</small> </span>   
          </td> 
          <td style="width: 6%;">Pay.Term</td> 
          <td style="width: 19%;"> 
            <select [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentTerm" class="form-control form-control-sm field-bg-color"   [class.is-invalid]="formErrors.paymentTerm" (blur)="logValidationErrors()">        
              <option [ngValue]="null">-Select-</option>
              <option *ngFor="let item of PMT_TERM" [value]="item.value">
                {{item.value}}
              </option>
          </select>
          <span class="text-danger" *ngIf="formErrors.paymentTerm"><small>{{formErrors.paymentTerm}}</small> </span>   
        </td>                  
        </tr> 

        <tr class="table-row-color">                      
          <td style="width: 6%;">Req By</td> 
          <td style="width: 19%;">
          <input [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="requestedBy"  placeholder="Requested By">
          </td> 
          <td style="width: 6%;">Job No</td> 
          <td style="width: 19%;">
            <input readonly [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="jobNo"  placeholder="Job No">
          </td>
          <td style="width: 6%;">VATNo</td> 
          <td style="width: 19%;">
            <input readonly [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="vatNo"  placeholder="VAT No">
          </td>
          <td style="width: 6%;">SVATNo</td> 
          <td style="width: 19%;">
            <input readonly [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="svatNo"  placeholder="SVAT No">
          </td>
        </tr>

          <tr class="table-row-color">                      
            <td style="width: 6%;">PO No.</td> 
            <td style="width: 19%;">
            <input [ngClass]="{'dark-input-field' : isDark }"  class="form-control form-control-sm field-bg-color" formControlName="poNo"  placeholder="PO Number">
            </td> 
         </tr>
                  
                </tbody>
            </table> 
          </div> 
        </div>



        <div class="row"> 
          <div class="col-md-12">
          <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
            <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
              <tr>
                <th style="width: 20%"  scope="col">Item Code</th>
                <th style="width: 25%"  scope="col">Description</th>
                <th style="width: 10%"  scope="col">Sales Type</th>
                <th style="width: 15%"  scope="col" style="text-align: center">UnitPrice</th>
                <th style="width: 10%"  scope="col" style="text-align: center">Qty</th>
                <th style="width: 20%" scope="col" style="text-align: center">Amount</th>
                <th *ngIf="!isHideBtn"></th> 
              </tr>
              </thead>
  
              <tbody class="ml-1" formArrayName="invoiceItems" *ngFor="let invoiceItem of invoiceForm.get('invoiceItems')['controls']; let i = index">                    
                    <tr [formGroupName] = "i" >                      
                      <td><input  (focusout)="getItemData(i);calEachItemAmount(i)" [matAutocomplete]="auto" [readonly]="isfieldReadOnly" [ngClass]="{'dark-input-field' : isDark }" type="text"  class="form-control form-control-sm field-bg-color" formControlName="itemCode" [class.is-invalid]="invoiceItem.get('itemCode').invalid && invoiceItem.get('itemCode').touched">
                        <mat-autocomplete autoActiveFirstOption   #auto="matAutocomplete">
                          <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.ItemCode">
                            {{option.ItemCode}}
                          </mat-option>
                        </mat-autocomplete> 
                      </td>   
                                         
                        <td><input [ngClass]="{'dark-input-field' : isDark }"   type="text" readonly class="form-control form-control-sm field-bg-color" formControlName="description" [class.is-invalid]="invoiceItem.get('description').invalid && invoiceItem.get('description').touched"></td> 
                        <td><input [ngClass]="{'dark-input-field' : isDark }"   type="text" readonly class="form-control form-control-sm field-bg-color" formControlName="salesType"></td> 
                        <td><input [ngClass]="{'dark-input-field' : isDark }" type="text" (keyup)="calEachItemAmount(i)"  style="text-align: right"   class="form-control form-control-sm field-bg-color" formControlName="unitPrice" allowNumberOnly [class.is-invalid]="invoiceItem.get('unitPrice').invalid && invoiceItem.get('unitPrice').touched"></td>  
                        <td><input (focusout)="calEachItemAmount(i)" (keyup)="calEachItemAmount(i)"  [ngClass]="{'dark-input-field' : isDark }"  [readonly]="isfieldReadOnly" type="text"  style="text-align: right" allowNumberOnly   class="form-control form-control-sm field-bg-color" formControlName="qty" [class.is-invalid]="invoiceItem.get('qty').invalid && invoiceItem.get('qty').touched"></td>  
                        <td><input (focusout)="calEachItemAmount(i)"  [ngClass]="{'dark-input-field' : isDark }"  type="text" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="amount" [class.is-invalid]="invoiceItem.get('amount').invalid && invoiceItem.get('amount').touched"></td>  
                        <td *ngIf="!isHideBtn">
                          <button type="button" *ngIf="!isBtnDisabled && invoiceForm.get('invoiceItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                      </td>                   
                      </tr>                                                         
              </tbody>
              <tfoot *ngIf="!isHideBtn">
                <tr>
                  <td colspan="7"><button  [disabled]="isBtnDisabled || invoiceForm.get('invoiceItems').invalid" type="button" class="btn btn-success btn-sm text-white float-right" (click)="addItemButtonClick()"><i class="fa fa-plus"></i> Add</button></td>
                </tr>   
              </tfoot>
          </table> 
        </div> 
      </div>

          <div class="row mt-3 mr-4">
            <div class="col-md-4" *ngIf="showInvoicePmtDetails">
              <div class="form-group">
            <table class="table  table-clear table-sm" [ngClass]="{'dark-bg' : isDark }">
            <tbody>
              <tr>
                <td colspan="2" class="text-center pt-2"><strong>Invoice Details</strong></td>                
            </tr> 
             <tr>
                <td  class="pt-2">Status</td>
                <td><span class="badge" [ngClass]="{'badge-warning' : invoice.status==='Unpaid', 'badge-success' : invoice.status==='Paid','badge-info' : invoice.status==='Partially paid','badge-danger' : invoice.status==='Canceled' }" >{{invoice.status}}</span></td>
            </tr> 
            <tr>
              <td class="pt-2">Invoice Total</td>
               <td>{{invoice.grandTotal |  number:'1.2-2'}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Paid Amount</td>
               <td>{{invoice.amountPaid |  number:'1.2-2'}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Balance Due</td>
               <td>{{invoice.balToPay |  number:'1.2-2'}}</td>
            </tr> 
            <tr>
              <td class="pt-2">Created By</td>
               <td>{{invoice.createdBy}}</td>
            </tr>
            </tbody>
          </table>
              </div>
          </div>

          <div class="col-md-4" [class.offset-md-4]='!bsClassToShow'> 
            <div class="form-group">
              <label for="reorderLevel" class="col-form-label">Remarks</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                </div>
                <textarea  [ngClass]="{'dark-input-field' : isDark }" formControlName="remarks" placeholder="Remarks" class="form-control field-bg-color"  rows="3"></textarea>
              </div>               
            </div>        
          </div>
        
          <div class="col-md-4">
            <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
              <tbody>
              <tr class="row">
              <td class="left col-sm-4">
              <strong>Total</strong>
              </td>  
              <td class="col-sm-3"></td>             
              <td class="text-right col-sm-5">
              <strong>{{invoice.grandTotal | number:'1.2-2'}}</strong>
              </td>
              </tr>
              <tr class="row">
                <td class="left col-sm-4">
                  <mat-checkbox  [(ngModel)]="selectChkBox" [ngModelOptions]="{standalone: true}" [disabled]="isBtnDisabled" (change)="selectReceivedAmountCheckBoxChange($event)"><strong>Paid</strong></mat-checkbox>                     
                </td>  
                <td class="col-sm-2"></td>           
                <td class="col-sm-6"><input [ngClass]="{'dark-bg' : isDark }" [readonly]="isfieldReceivedReadOnly" style="text-align: right" [(ngModel)]="invoice.amountPaid" (keyup)="updateBillTotal()" (focusout)="receivedFieldFocusOut()" [ngModelOptions]="{standalone: true}" class="form-control form-control-sm field-bg-color"></td>
                </tr>
                <tr class="row" *ngIf="isPaidChecked">
                  <td class="left col-sm-4">
                  <strong>Pmt Method</strong>
                  </td>             
                  <td class="text-right col-sm-8">
                    <select  [ngClass]="{'dark-input-field' : isDark }" [(ngModel)]="paymentType" [ngModelOptions]="{standalone: true}" class="form-control field-bg-color">        
                      <option [ngValue]="null">-Select-</option>
                      <option *ngFor="let item of PMT_METHOD" [value]="item.value">
                        {{item.value}}
                      </option>
                  </select>
                  </td>
                  </tr> 
                  <tr class="row" *ngIf="isPaidChecked">
                    <td class="left col-sm-4">
                    <strong>Dep. A/C</strong>
                    </td>           
                    <td class="text-right col-sm-8">
                      <select  [ngClass]="{'dark-input-field' : isDark }" [(ngModel)]="depositAccount" [ngModelOptions]="{standalone: true}" class="form-control field-bg-color">        
                        <option [ngValue]="null">-Select-</option>
                        <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                          {{item.AccountName}}
                        </option>
                    </select>
                    </td>
                    </tr> 
                <tr class="row">
                  <td class="left col-sm-5">
                  <strong>Balance Due</strong>
                  </td>
                  <td class="col-sm-2"></td>                
                  <td class="text-right col-sm-5">
                  <strong>{{invoice.balToPay | number:'1.2-2'}}</strong>
                  </td>
                  </tr> 
              </tbody>
              </table>              
                <input  readonly  [(ngModel)]="receiptNo" [ngModelOptions]="{standalone: true}" class="form-control"   type="hidden">
        </div>
        </div>
  
      
        </div>
        
        <!-- /.card-body -->
          
        <div class="card-footer">
        <button type="button" *ngIf="crud_access.create" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
          <button type="button" *ngIf="crud_access.create && !isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
          <button type="button"  *ngIf="crud_access.create  && !isEditBtnDisabled" class="btn btn-secondary ml-2"  (click)="editButtonClick()">Edit</button>
          <button type="button" *ngIf="crud_access.delete && !isCancelBtnDisabled" class="btn btn-danger ml-2"  (click)="deleteButtonClick()">Cancel</button>
          <button type="button" class="btn btn-success ml-2" routerLink="../invoice-list"><i class="fa fa-table p-1"></i>Invoice List</button>
          <button type="button" *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>
          <button type="button" *ngIf ="crud_access.createReceipt && isShowPayBtn" class="btn btn-success ml-2" (click)="payButtonClicked()"><i class="fa fa-sign-out-alt p-1"></i>Pay</button>
 
         
          
          <button type="button" (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
            <mat-icon>print</mat-icon>
          </button>
          <button type="button" (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
            <mat-icon>cloud_download</mat-icon>
          </button>
          <button type="button" (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
            <mat-icon [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
          </button>
        
        </div>

        </form>
      </div>
  
    </section>

  </div> 

     <!-- Form Values : {{ invoiceForm.value | json }}   -->



  
